import { z } from "zod";

export const customerGroupSchema = z.object({
  descricao: z.string()
    .min(2, "Descrição deve ter no mínimo 2 caracteres")
    .max(60, "Descrição deve ter no máximo 60 caracteres"),
  isInativo: z.boolean().optional().default(false),
});

export type CustomerGroupFormData = z.infer<typeof customerGroupSchema>;
